import { Routes } from '@angular/router'
import { AuthGuard } from '@auth0/auth0-angular'
import { adminGuard } from './guards/admin.guard'
import { chatRouteGuard } from './guards/chat-route.guard'
import { defaultRouteGuard } from './guards/default-route.guard'

export const routes: Routes = [
  { path: '', canActivate: [defaultRouteGuard], children: [] },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/user-dashboard/user-dashboard.component').then(m => m.UserDashboardComponent),
    canActivate: [AuthGuard],
    children: [
      { path: '', canActivate: [defaultRouteGuard], children: [] },
      {
        path: 'chat',
        loadComponent: () => import('./pages/user-dashboard/chat/chat-page.component').then(m => m.ChatPageComponent),
        canActivate: [chatRouteGuard],
      },
      {
        path: 'media-library',
        loadComponent: () =>
          import('./pages/user-dashboard/media-library-new/media-library-new.component').then(
            m => m.MediaLibraryNewComponent
          ),
      },
      {
        path: 'media-library/:publisherId',
        loadComponent: () =>
          import('./pages/user-dashboard/media-library-new/media-library-new.component').then(
            m => m.MediaLibraryNewComponent
          ),
      },
      {
        path: 'all-chats',
        loadComponent: () => import('./pages/user-dashboard/all-chats/all-chats').then(m => m.AllChatsComponent),
      },
      {
        path: 'projects',
        loadComponent: () => import('./pages/user-dashboard/projects/projects').then(m => m.ProjectsComponent),
      },
      {
        path: 'projects/:id',
        loadComponent: () =>
          import('./pages/user-dashboard/projects/project-detail/project-detail').then(m => m.ProjectDetailComponent),
      },
      {
        path: 'projects/:id/chats',
        loadComponent: () =>
          import('./pages/user-dashboard/projects/project-chats-list/project-chats-list').then(
            m => m.ProjectChatsListComponent
          ),
      },
      {
        path: 'projects/:id/chats/:chatId',
        loadComponent: () => import('./pages/user-dashboard/chat/chat-page.component').then(m => m.ChatPageComponent),
      },
      {
        path: 'projects/:id/assets',
        loadComponent: () =>
          import('./pages/user-dashboard/projects/project-assets-list/project-assets-list').then(
            m => m.ProjectAssetsListComponent
          ),
      },
      {
        path: 'projects/:id/reels',
        loadComponent: () =>
          import('./pages/user-dashboard/projects/project-playlists-list/project-playlists-list').then(
            m => m.ProjectPlaylistsListComponent
          ),
      },
      {
        path: 'projects/:id/reels/:playlistId',
        loadComponent: () => import('./pages/user-dashboard/projects/project-playlists-list/playlist/playlist.component').then(m => m.PlaylistComponent),
      },
      {
        path: 'reels/:id',
        loadComponent: () => import('./pages/user-dashboard/projects/project-playlists-list/playlist/playlist.component').then(m => m.PlaylistComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/user-dashboard/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: 'contact-us',
        loadComponent: () => import('./pages/user-dashboard/contact-us/contact-us.component').then(m => m.ContactUsComponent),
      },
      {
        path: 'terms-of-service',
        loadComponent: () =>
          import('./pages/user-dashboard/terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent),
      },
      {
        path: 'sources',
        loadComponent: () => import('./pages/user-dashboard/sources/sources').then(m => m.SourcesComponent),
      },
    ],
  },
  {
    path: 'vm-mh-admin-app',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/admin-dashboard/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent),
        canActivate: [adminGuard],
        children: [
          {
            path: '',
            redirectTo: 'sources',
            pathMatch: 'full' as const,
          },
          {
            path: 'sources',
            loadComponent: () =>
              import('./pages/admin-dashboard/sources/sources.component').then(m => m.AdminSourcesComponent),
          },
          {
            path: 'users',
            loadComponent: () =>
              import('./pages/admin-dashboard/users/users.component').then(m => m.AdminUsersComponent),
          },
        ],
      },
    ],
  },
  {
    // DEMO, no guard: the sports analysis panel on two real documents, for the UI team.
    path: 'demo/sports-panel',
    loadComponent: () => import('./pages/demo/sports-panel-demo.component').then(m => m.SportsPanelDemoComponent),
  },
  { path: '**', canActivate: [defaultRouteGuard], children: [] },
]
